import Hero from "../components/Hero/Hero";
import Information from "../components/Information/Information";
import Navbar from "../components/Navbar/Navbar";
import vid from "../assets/videos/video-2.mp4";
import Footer from "../components/Footer/Footer";

function Home() {
  return (
    <>
      <Navbar />
      <Hero
        cName="hero"
        src={vid}
        alt="video"
        type="video"
        title="Hello! My name is Luis!"
        text="And I am a Software Developer!"
        btnText="Download my resume!"
        url="/"
        btnClass="show"
      />
      <Information />
      <Footer />
    </>
  );
}

export default Home;
